//-------
// ucfirst
//-------
module.exports = function (str) {
  return `${str.slice(0, 1).toUpperCase()}${str.slice(1).toLowerCase()}`;
};
